import useDevice from '@/hooks/useDevice'
import { useRouter } from 'next/router'
import React, { useEffect, useRef, useState } from 'react'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

const useHeader = ({ params, mapIsOpen, defaultLightMode }) => {
  const { isMobile } = useDevice()
  const router = useRouter()
  const [defaultSearchTxt, setDefaultSearchTxt] = useState('')
  const [lightMode, setLightMode] = React.useState(defaultLightMode)
  const [nextUrl, setNextUrl] = React.useState<string>('')
  const isLightMode = React.useMemo(() => lightMode, [lightMode])

  const handleScroll = React.useCallback(() => {
    const scrollSize = window.pageYOffset || document.documentElement.scrollTop
    if (scrollSize > 200) {
      setLightMode(true)
    } else {
      setLightMode(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isSearchPage = router.pathname.includes('/search')
  const isProductPage = router.pathname.includes('/houses/show')
  const isHomePage = router.pathname === '/'
  const [showHeader, setShowHeader] = useState(true)
  const [positionValue, setPositionValue] = useState('sticky')
  const firstTimeTransition = useRef(false)

  useScrollPosition(({ currPos, prevPos }) => {
    if (isHomePage && isMobile) {
      if (currPos.y < -280) {
        setPositionValue('sticky')
        setTimeout(() => {
          firstTimeTransition.current = true
        }, 300)
      } else {
        setPositionValue('relative')
        firstTimeTransition.current = false
      }
    } else {
      firstTimeTransition.current = true
    }
    if ((isHomePage || isProductPage) && isMobile) {
      if (currPos.y < prevPos.y && currPos.y < -280) {
        setShowHeader(false)
      } else {
        setShowHeader(true)
      }
    }
  })

  useEffect(() => {
    setDefaultSearchTxt(
      params?.city ||
        params?.province ||
        params?.village ||
        params?.phrase ||
        '',
    )
  }, [params])

  useEffect(() => {
    setNextUrl(`?next=${window.location.pathname}${window.location.search}`)

    if (!lightMode) {
      window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isSearchPage && (mapIsOpen || isMobile)) {
      setPositionValue('relative')
    } else {
      setPositionValue('sticky')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.pathname, mapIsOpen])

  return {
    defaultSearchTxt,
    showHeader,
    positionValue,
    isMobile,
    isLightMode,
    firstTimeTransition,
  }
}

export default useHeader
